import React from "react";
import styled from "styled-components";

export default styled.div`
    color: white;
    position: absolute;
    top: -30px;
    right: 0;
    cursor: pointer;
`;